/* eslint-disable @typescript-eslint/no-explicit-any */

import { ENTER_DELAY, LEAVE_DELAY, HYSTERSIS_DELAY } from '../../../../internal';
import { useControlled } from '../../../../../internal/hooks';
/**
 * Это общее состояние для тултипов нужно для того чтобы не дожидаться задержки на открытие тултипа,
 * если один из тултипов уже был открыт совсем недавно
 *
 * https://github.com/mui-org/material-ui/pull/18458
 */
let hystersisOpen = false;
let hystersisTimer;
export function useTooltipControllerOpen(dependencies) {
  const {
    childrenRef,
    state,
    props
  } = dependencies;
  const {
    timers
  } = state;
  const {
    children,
    onOpen,
    onClose
  } = props;
  const [open, setOpen] = useControlled({
    controlled: props.open,
    default: false
  });
  const handleOpen = () => {
    if (open) {
      return;
    }
    window.clearTimeout(hystersisTimer);
    hystersisOpen = true;
    setOpen(true);
    if (onOpen) {
      onOpen();
    }
  };
  const handleClose = () => {
    window.clearTimeout(timers.enter);
    window.clearTimeout(hystersisTimer);
    hystersisTimer = window.setTimeout(() => {
      hystersisOpen = false;
    }, HYSTERSIS_DELAY + LEAVE_DELAY);
    setOpen(false);
    if (onClose) {
      onClose();
    }
    state.ignoreNonTouchEvents = false;
  };
  const createHandleEnter = forward => event => {
    const childrenProps = children.props;
    if (event.type === 'mouseenter' && childrenProps.onMouseEnter && forward) {
      childrenProps.onMouseEnter(event);
    }
    if (state.ignoreNonTouchEvents && event.type !== 'touchstart') {
      return;
    }

    // Удаление title чтобы он не пересекался с тултипом
    // Дожидаться ререндера не нужно
    if (childrenRef.current) {
      childrenRef.current.removeAttribute('title');
    }
    clearTimeout(timers.enter);
    clearTimeout(timers.leave);
    if (ENTER_DELAY && !hystersisOpen) {
      timers.enter = window.setTimeout(() => {
        handleOpen();
      }, ENTER_DELAY);
    } else {
      handleOpen();
    }
  };
  const handleLeave = event => {
    const childrenProps = children.props;
    if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childrenRef.current) {
      childrenProps.onMouseLeave(event);
    }
    clearTimeout(timers.enter);
    clearTimeout(timers.leave);
    timers.leave = window.setTimeout(() => {
      handleClose();
    }, LEAVE_DELAY);
  };
  return {
    open,
    handleOpen,
    handleClose,
    createHandleEnter,
    handleLeave
  };
}